import Vue from 'vue';
import VueRouter from 'vue-router';
import LoginForm from '../views/LoginForm.vue';
Vue.use(VueRouter);

const routes = [
  // Mobile
  {
    path: '/identifier/login/:data/:browser?',
    name: 'LoginForm',
    component: LoginForm,
  },

  {
    path: '/identifier/sms/:data/:browser/:smsInfo',
    name: 'SMSVerificationForm',
    component: () =>
      import(
        /* webpackChunkName: "SMSVerificationForm" */ '../views/SMSVerificationForm.vue'
      ),
  },

  {
    path: '/identifier/authenticator/:data/:browser/:authenticatorInfo?',
    name: 'AuthVerificationForm',
    component: () =>
      import(
        /* webpackChunkName: "AuthVerificationForm" */ '../views/AuthVerificationForm.vue'
      ),
  },
  {
    path: '/identifier/complete/:data',
    name: 'complete',
    component: () =>
      import(
        /* webpackChunkName: "complete" */ '../views/complete.vue'
      ),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
